module.exports = __webpack_public_path__ + "img/entry.d212d835.svg";